import type { OrderDetails } from '@ts-orders/interfaces'

import { useCommonStore } from '@stores/common'
import { useOrderStore } from '@stores/order'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { runApiGet } from '@utils/api/run-api-get'

/** `GET /admin-api/orders/{order}` — header, info, items and the payment log of one order. */
export const useOrderShowApi = async (orderId: string | number): Promise<OrderDetails | null> => {
  const orderStore = useOrderStore()
  const commonStore = useCommonStore()

  return runApiGet<OrderDetails>(useAdminRoutes('admin.order.details', { order_id: orderId }), {
    setLoading: commonStore.setLoading,
    handle: (response) => {
      const order: OrderDetails = response.data
      orderStore.setOrder(order)
      return order
    },
  })
}
